module.exports = __webpack_public_path__ + "static/media/activity_type_beweging.740e425f.svg";